import React from 'react';
import GeneralSection from './sections/GeneralSection';
import MembersSection from './sections/MembersSection';
import RolesSection from './sections/RolesSection';
import PoliciesPlaceholder from './sections/PoliciesPlaceholder';
import CatalogPlaceholder from './sections/CatalogPlaceholder';
import ActivitySection from './sections/ActivitySection';
import DangerZoneSection from './sections/DangerZoneSection';
import BillingMockSection from './sections/BillingMockSection';
import AgentsMockSection from './sections/AgentsMockSection';
import DeveloperMockSection from './sections/DeveloperMockSection';
import RequireMocksGate from './RequireMocksGate';

export interface OrgSettingsSection {
  id: string;
  labelKey: string;
  icon: string;
  listElement: React.ReactNode;
  /** When true, this section is hidden unless feature_settings_mocks_enabled gate is on. */
  mocked?: boolean;
}

export const SETTINGS_SECTIONS: OrgSettingsSection[] = [
  {
    id: 'general',
    labelKey: 'orgSettings.sections.general',
    icon: 'pi pi-cog',
    listElement: <GeneralSection />,
  },
  {
    id: 'members',
    labelKey: 'orgSettings.sections.members',
    icon: 'pi pi-users',
    listElement: <MembersSection />,
  },
  {
    id: 'roles',
    labelKey: 'orgSettings.sections.roles',
    icon: 'pi pi-shield',
    listElement: <RolesSection />,
  },
  {
    id: 'policies',
    labelKey: 'orgSettings.sections.policies',
    icon: 'pi pi-lock',
    listElement: <PoliciesPlaceholder />,
  },
  {
    id: 'catalog',
    labelKey: 'orgSettings.sections.catalog',
    icon: 'pi pi-th-large',
    listElement: <CatalogPlaceholder />,
  },
  {
    id: 'activity',
    labelKey: 'orgSettings.sections.activity',
    icon: 'pi pi-list',
    listElement: <ActivitySection />,
  },
  {
    id: 'danger',
    labelKey: 'orgSettings.sections.danger',
    icon: 'pi pi-exclamation-triangle',
    listElement: <DangerZoneSection />,
  },
  {
    id: 'billing',
    labelKey: 'orgSettings.sections.billing',
    icon: 'pi pi-credit-card',
    listElement: (
      <RequireMocksGate>
        <BillingMockSection />
      </RequireMocksGate>
    ),
    mocked: true,
  },
  {
    id: 'agents',
    labelKey: 'orgSettings.sections.agents',
    icon: 'pi pi-android',
    listElement: (
      <RequireMocksGate>
        <AgentsMockSection />
      </RequireMocksGate>
    ),
    mocked: true,
  },
  {
    id: 'developer',
    labelKey: 'orgSettings.sections.developer',
    icon: 'pi pi-code',
    listElement: (
      <RequireMocksGate>
        <DeveloperMockSection />
      </RequireMocksGate>
    ),
    mocked: true,
  },
];
